import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { VehicleShowcase } from "./components/VehicleShowcase";
import { RentalSection } from "./components/RentalSection";
import { Simulator } from "./components/Simulator";
import { Platform } from "./components/Platform";
import { LeadForm } from "./components/LeadForm";
import { Faq } from "./components/Faq";
import { Testimonials } from "./components/Testimonials";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Admin from "./pages/Admin";
import VehicleDetail from "./pages/VehicleDetail";
import AssinarContrato from "./pages/AssinarContrato";

function Landing() {
  const [simVehicle, setSimVehicle] = useState(null);
  const [interest, setInterest] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  const scrollTo = useCallback((id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const handleSimulate = useCallback((v) => {
    setSimVehicle(v);
    scrollTo("#simulador");
  }, [scrollTo]);

  const handleInterest = useCallback((v) => {
    setInterest(v);
    scrollTo("#contato");
  }, [scrollTo]);

  return (
    <>
      <Navbar />
      <Hero />
      <Marquee />
      <VehicleShowcase onSimulate={handleSimulate} onInterest={handleInterest} />
      <RentalSection />
      <Simulator vehicle={simVehicle} />
      <Platform />
      <Testimonials />
      <Faq />
      <LeadForm interest={interest} />
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/veiculo/:id" element={<VehicleDetail />} />
          <Route path="/assinar/:rentalId" element={<AssinarContrato />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
